import * as React from 'react';

/**
 * Yeni surum algilama.
 *
 * Resepsiyon sekmesi vardiya boyunca - cogu zaman gunlerce - acik kalir.
 * Tek sayfali uygulama acildiktan sonra `index.html`i bir daha istemez, bu
 * yuzden dagitimdan sonra ekran ESKI paketi calistirmaya devam eder: yeni
 * ozellik "gelmemis" gorunur, daha kotusu eski istemci yeni API ile
 * konusur. Fark yalnizca sert bir yenilemeyle kapanir ve bunu kimse bilmez.
 *
 * Cozum: sayfa gorunurken seyrek araliklarla `index.html` okunur ve icindeki
 * paket adi, sayfayi SU AN calistiran paketle karsilastirilir.
 *
 * KENDILIGINDEN YENILEMEYIZ. Gorevli yarim kalmis bir check-in'in ortasinda
 * olabilir; sayfayi altindan cekmek veri kaybettirir. Yalnizca haber verilir,
 * ne zaman yenilenecegine kullanici karar verir.
 */

const PAKET_DESENI = /\/assets\/(index-[A-Za-z0-9_-]+\.js)/;

/** Sayfayi su an calistiran paketin dosya adi. Gelistirmede hash yoktur. */
export function calisanPaket(belge: Document = document): string | null {
  for (const s of belge.querySelectorAll('script[src]')) {
    const e = PAKET_DESENI.exec((s as HTMLScriptElement).getAttribute('src') ?? '');
    if (e) return e[1]!;
  }
  return null;
}

/** Sunucudaki guncel paketin adi. Okunamazsa null. */
export async function yayindakiPaket(): Promise<string | null> {
  try {
    const cevap = await fetch('/index.html', { cache: 'no-store' });
    if (!cevap.ok) return null;
    return PAKET_DESENI.exec(await cevap.text())?.[1] ?? null;
  } catch {
    // Cevrimdisi olabiliriz; bu bir hata degil, sadece bilgi yok.
    return null;
  }
}

/** Sayfayi tazeler. Servis calisani da guncellensin ki kabuk eski kalmasin. */
export async function yenidenYukle(): Promise<void> {
  try {
    const kayit = await navigator.serviceWorker?.getRegistration();
    await kayit?.update();
  } catch {
    /* servis calisani yoksa onemsiz */
  }
  location.reload();
}

export function useYeniSurum(aralikMs = 5 * 60_000): boolean {
  const [yeni, setYeni] = React.useState(false);

  React.useEffect(() => {
    const calisan = calisanPaket();
    // Gelistirme sunucusunda paket adi hash'siz gelir: karsilastiracak sey yok.
    if (!calisan) return;

    let bitti = false;
    const bak = async () => {
      if (bitti || document.visibilityState !== 'visible') return;
      const yayinda = await yayindakiPaket();
      if (yayinda && yayinda !== calisan) {
        bitti = true;
        setYeni(true);
      }
    };

    const zamanlayici = setInterval(() => void bak(), aralikMs);
    // Sekmeye geri donuldugunde de bak: gece boyunca acik kalmis olabilir.
    // Dinleyici ADLI olmali; ayni referans verilmezse kaldirilamaz.
    const gorunurlukDegisti = () => void bak();
    document.addEventListener('visibilitychange', gorunurlukDegisti);
    return () => {
      bitti = true;
      clearInterval(zamanlayici);
      document.removeEventListener('visibilitychange', gorunurlukDegisti);
    };
  }, [aralikMs]);

  return yeni;
}
